import { useCallback, useEffect, useRef, useState } from 'react';
import ComboBox from '../Input/ComboBox';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function SelectObjectStaff({
    label = 'select_staff',
    valueSelect = null,
    getValue = (e) => e,
    sizeCbb = 'medium',
    department_id = 0,
    disabled = false,
}) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [value, setValue] = useState([]);
    const getRef = useRef(false);
    useEffect(() => {
        setTimeout(() => {
            getData(department_id);
        }, 500);
    }, [department_id]);
    useEffect(() => {
        setValue(valueSelect);
        console.log('valueSelect', valueSelect);
    }, [valueSelect]);

    const handleOnchangeValue = (e) => {
        setValue(e);
        getValue(e);
    };
    const getData = useCallback((id) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = ['%%', id || 0];
        sendRequest(serviceList.getAllUserList, InVal, getDataResult, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            setData(data);
            if (valueSelect) setValue(valueSelect);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getRef.current = false;
    };
    return (
        <>
            <ComboBox
                label={t(label)}
                valueSelect={value}
                displayLabel="user_nm"
                valueEqual="id"
                getValue={handleOnchangeValue}
                selectOption={data}
                sizeCbb={sizeCbb}
                disabled={disabled}
            />
        </>
    );
}

export default SelectObjectStaff;
